/**
 * Processes a URL and returns an object with information about whether it's absolute
 * and the normalized URL with protocol if needed
 * @param url - The URL to process
 * @returns Object with isAbsolute boolean and normalizedUrl string
 */
export const processUrl = (
  url: string,
): {
  isAbsolute: boolean
  normalizedUrl: string
} => {
  if (!url) return { isAbsolute: false, normalizedUrl: url }

  try {
    // If URL constructor succeeds, it's already an absolute URL
    new URL(url)
    return { isAbsolute: true, normalizedUrl: url }
  } catch {
    // Check for protocol-relative URLs
    if (url.startsWith('//')) {
      return { isAbsolute: true, normalizedUrl: `https:${url}` }
    }

    // Check for domain names without protocol (like www.westjet.com)
    const domainPattern =
      /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\/.*)?$/

    if (domainPattern.test(url)) {
      return { isAbsolute: true, normalizedUrl: `https://${url}` }
    }

    // Otherwise it's a relative URL
    return { isAbsolute: false, normalizedUrl: url }
  }
}
